import { render, staticRenderFns } from "./ModalSeminarDownload.vue?vue&type=template&id=85260510&scoped=true"
import script from "./ModalSeminarDownload.vue?vue&type=script&lang=js"
export * from "./ModalSeminarDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85260510",
  null
  
)

export default component.exports